export enum AmplitudeEventsBulkBrandedEmails {
    BRANDED_EMAILS_GO_BACK = 'go back to branded emails',
    BRANDED_EMAILS_SEND_TEST_EMAIL = 'send test email',
    BRANDED_EMAILS_SAVE_BRANDED_EMAIL = 'save branded email',
    BRANDED_EMAILS_SAVE_BRANDED_EMAIL_MODAL = 'save branded email modal',
    BRANDED_EMAILS_ACTIVATE_BRANDED_EMAIL_MODAL = 'Activate branded email modal',
}
